export const dictKeyWord = {
  必备好书: "book",
  超值推荐: "book",
  必刷好题: "exam",
  推荐好题: "exam",
  必学好课: "course",
  教师热门活动: "research_project",
  学生热门活动: "thematic_activities",
  推荐成果: "research_result",
  新书推荐: "new_book",
  新书上架: "new_book",
  热门资源: "hot_resource",
};
// 这是最初的时候，后端接口返回的数据。2024年11月4日14:16:48
export const dictBookType = [
  {
    id: 12,
    name: "专题类",
  },
  {
    id: 14,
    name: "真题汇编",
  },
  {
    id: 15,
    name: "汇编类",
  },
  {
    id: 16,
    name: "专项类",
  },
  {
    id: 17,
    name: "原创卷",
  },
  {
    id: 18,
    name: "学考类",
  },
  {
    id: 19,
    name: "同步类",
  },
  {
    id: 20,
    name: "工具类",
  },
  {
    id: 21,
    name: "总复习",
  },
  {
    id: 13,
    name: "真题类",
  },
  {
    id: 9,
    name: "超级全能生",
  },
  {
    id: 1,
    name: "解锁高考",
  },
  {
    id: 2,
    name: "高考模拟",
  },
  {
    id: 3,
    name: "高考真题",
  },
  {
    id: 4,
    name: "全国卷系列",
  },
  {
    id: 5,
    name: "教学考试杂志",
  },
  {
    id: 6,
    name: "浙江新高考",
  },
  {
    id: 23,
    name: "测试分类",
  },
  {
    id: 7,
    name: "中考",
  },
  {
    id: 8,
    name: "小学",
  },
  {
    id: 11,
    name: "技术",
  },
  {
    id: 10,
    name: "其他",
  },
];
